export default {
  ASX: 'https://www.asx.com.au/asx/share-price-research/company',
  NZSE: 'https://www.nzx.com/companies',
  NASDAQ: 'https://www.nasdaq.com',
  NASDAQCM: 'https://www.nasdaq.com',
  NASDAQGM: 'https://www.nasdaq.com',
  NASDAQGS: 'https://www.nasdaq.com',
  NYSE: 'https://www.nasdaq.com',
  AMEX: 'https://www.nasdaq.com',
  ARCA: 'https://www.nasdaq.com',
  AIM: 'http://www.londonstockexchange.com/home/homepage.htm',
  LSE: 'http://www.londonstockexchange.com/home/homepage.htm',
  TSX: 'https://web.tmxmoney.com/financials.php',
  TSXV: 'https://web.tmxmoney.com/financials.php',
  CNSX: 'https://web.tmxmoney.com/financials.php',
  SEHK: 'https://www.hkex.com.hk/Market-Data/Securities-Prices/Equities/Equities-Quote?sc_lang=en',
  SGX: 'http://www.sgx.com/wps/portal/sgxweb/home/company_disclosure/company_announcements',
  NSEI: 'https://www.bseindia.com/corporates/Comp_Resultsnew.aspx?expandable=3',
  BSE: 'https://www.bseindia.com/corporates/Comp_Resultsnew.aspx?expandable=3',
  CPSE: 'https://www.nasdaqomxnordic.com',
  WSE: 'https://www.gpw.pl',
  DB: 'https://deutsche-boerse.com/dbg-en',
  BDL: 'https://www.bourse.lu/home',
  SWX: 'https://www.six-swiss-exchange.com/index.html',
  HLSE: 'https://www.nasdaqomxnordic.com',
  MISX: 'https://www.moex.com/en',
  ATSE: 'https://www.helex.gr',
  ENXTLS: 'https://www.bolsadelisboa.com.pt',
  ISE: 'http://www.ise.ie',
  BST: 'http://en.boerse-frankfurt.de',
  OB: 'https://www.oslobors.no',
  MUN: 'https://www.boerse-muenchen.de/home',
  ENXTPA: 'https://www.boursedeparis.fr',
  OM: 'http://www.nasdaqomxnordic.com',
  WBAG: 'http://www.wienerborse.at',
  ENXTBR: 'https://www.beurs.be',
  BIT: 'http://www.borsaitaliana.it/homepage/homepage.en.htm',
  BRSE: 'https://www.six-swiss-exchange.com/index.html',
  ENXTAM: 'http://www.aex.nl',
  BME: 'http://www.bolsamadrid.es/ing/Nosotros/bme.aspx',
  BUSE: 'https://bse.hu',
  XTRA: 'http://www.xetra.com/xetra-en',
  OTCPK: 'https://www.otcmarkets.com',
};
